module.exports = __webpack_public_path__ + "static/media/Finance-e-Administrative.68810a9e.png";